 <app-sidenav class="pt-3">
    <div class="mt-4 pt-2">
        <div class="row mt-5 p-3 custom-box col-12">
            <div class="col-sm-12 py-1 px-3 d-flex justify-content-between flex-wrap">
                <h2 class="page-title text-left">
                    Instituição Financeira: {{dadosInstituicao?.nome}}
                </h2>
            <h2 class="page-title">
                Liquidação: {{dadosInstituicao?.liquidacao | date: 'dd/MM/yyyy'}}
            </h2>
        </div>
    </div>
    <div *ngIf="!solicitarDpge" class="row mt-3">
        <div class="box-form col-sm-12 m-0 p-lg-5 p-sm-3">
            <h3 class="text-title text-center">Lista de Ativos DPGE</h3>
            <hr class="w-100">
            <div class="d-flex m-0 p-0 flex-wrap justify-content-center gx-1">
              <form  [formGroup]="formSearch" (ngSubmit)="listarAtivos()" class="form-row box-form col-sm-12 m-0 p-4">
                <div *ngIf="query.tipoUsuario == 'ENTIDADE'" class="form-group col-sm-12 col-md-6 col-lg-4">
                  <label class="form-label">CPF / CNPJ</label>
                  <input
                    type="text"
                    name="documentoIdentificador"
                    formControlName="documentoIdentificador"
                    placeholder="Digite seu cpf ou cnpj"
                    mask="AAA.AAA.AAA-AA || AA.AAA.AAA/AAAA-AA"
                    [dropSpecialCharacters]="true"
                    class="form-control"
                  >
                </div>
                <div class="form-group col-sm-12 col-md-6 col-lg-4">
                  <label class="form-label">Código Ativo</label>
                  <input
                    type="text"
                    name="codigoAtivo"
                    formControlName="codigoAtivo"
                    placeholder="Digite o seu código ativo."
                    class="form-control custom-input"
                  >
                </div>
                <div class="form-group d-flex align-items-center mt-4 col-sm-12 col-md-6 col-lg-4">
                  <button type="submit" class="btn">Pesquisar</button>
                </div>
              </form>
                <div *ngIf="tableCard.length == 0" class="d-flex m-0 justify-content-center p-4">
                    <b class="text-danger">Não foram retornados registros de ativos para a Instituição financeira {{dadosInstituicao?.nome}}</b>
                </div>
                <div class="card mt-4 mx-sm-0 my-sm-3 custom-card-ativos col-sm-12 col-md-6 col-lg-4 ml-1 p-5" *ngFor="let card of tableCard | paginate:{ itemsPerPage: 2, currentPage: p}">
                <div class="row m-0">
                    <fieldset>
                        <legend class="title-ativo">Dados Solicitação</legend>
                        <p class="custom-info text-left">CPF / CNPJ :
                            <b *ngIf='card?.documentoIdentificador.length < 14' class="dataModal">{{card?.documentoIdentificador | mask: 'AAA.AAA.AAA-AA'}}</b>
                            <b *ngIf='card?.documentoIdentificador.length == 14' class="dataModal">{{card?.documentoIdentificador | mask: 'AA.AAA.AAA/AAAA-AA'}}</b>
                        </p>
                        <p class="custom-info text-left">Nome Investidor: <b class="dataModal">{{card?.nomeInvestidor}}</b></p>
                        <p class="custom-info text-left">Código Ativo: <b class="dataModal">{{card?.codigoDpge}}</b></p>
                    </fieldset>
                    <div class="col-12 d-flex justify-content-center">
                        <button (click)="openModalDetalhar(card)" class="btn btn-disabled">Ver Mais</button>
                    </div>
                </div>
                <div class="row m-0">
                    <fieldset >
                        <legend class="title-ativo">Status</legend>
                        <p class="custom-info text-left">Status: <b class="dataModal"><u>{{card?.descricaoStatusProcesso}}</u></b></p>
                    </fieldset>
                </div>
                <div class="row m-0">
                    <button class="btn w-100 mx-5" (click)='exibirMensagem(card.statusProcesso,card.tipoProcesso, card.idInvestidor)'>{{card?.descricaoProcesso}}</button>
                </div>
            </div>
        </div>
        <div class="row p-5 d-flex justify-content-center">
        <pagination-controls
        *ngIf="tableCard.length >= 2"
        class="d-flex justify-content-center"
        responsive="true"
        previousLabel="Voltar"
        nextLabel="Próximo"
        (pageChange)="p = $event"></pagination-controls>
        </div>
        </div>

        <div class="row m-3 d-flex justify-content-end">
            <button (click)="solicitarDpge = true" class="btn">Adicionar DPGE</button>
        </div>
    </div>
    <div *ngIf="solicitarDpge" class="row mt-3">
        <div class="box-form col-sm-12 m-0 p-lg-5 p-md-5 p-sm-0">
            <h3 class="text-title text-center">Lista de Ativos DPGE</h3>
            <hr class="w-100">
            <div class="d-flex m-0 flex-wrap justify-content-center">
                <form *ngIf="query.tipoUsuario == 'ENTIDADE' " class="custom-box p-2 col-12 my-3">
                    <div class="text-center">
                        <h2 class="form-titulo">Dados do Investidor</h2>
                        <small>Informe abaixo os dados do investidor</small>
                    </div>
                    <form [formGroup]="dadosInvestidor" class="col-sm-12 p-4">
                        <div class="form-row d-flex justify-content-center my-4">
              <div class="form-check form-check-inline">
                  <input mdbInput id="pessoaFisica"  value="pessoaFisica" name="tipoInvestidor" formControlName="tipoInvestidor" type="radio" class="form-check-input">
                  <label for="pessoaFisica" class="form-label">Pessoa Física</label>
            </div>
            <div class="form-check form-check-inline">
                  <input mdbInput id="pessoaJuridica" value="pessoaJuridica" name="tipoInvestidor" formControlName="tipoInvestidor" type="radio" class="form-check-input">
                  <label for="pessoaJuridica" class="form-label">Pessoa Jurídica</label>
              </div>
            <div class="form-check form-check-inline">
                <input mdbInput id="investidorFI" value="investidorFI" name="tipoInvestidor" formControlName="tipoInvestidor" type="radio" class="form-check-input">
                <label for="investidorFI" class="form-label">Fundo de Investimento</label>
            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12 col-md-4">
                                <label class="form-label">CPF / CNPJ <b class="text-danger">*</b></label>
                                <input placeholder="Digite o CPF/CNPJ"  [mask]="getCpfCnpjMask()" name='documentoIdentificador' formControlName="documentoIdentificador"  type="text" class="form-control">
                            </div>
                            <div class="form-group col-sm-12 col-md-8">
                                <label class="form-label">Nome Investidor / Razão Social <b class="text-danger">*</b></label>
                                <input type="text" placeholder="Informe seu nome" name='nomeInvestidor' formControlName="nomeInvestidor" class="form-control">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12 col-md-4">
                                <label class="form-label">E-Mail <b class="text-danger">*</b></label>
                                <input type="email" placeholder="Informe seu e-mail ex: example@example" name='email' formControlName="email" class="form-control">
                            </div>
                            <div class="form-group col-sm-12 col-md-4">
                                <label class="form-label">Telefone <i mdbTooltip='Este campo só é obrigatório caso o campo "Celular" não seja preenchido.'  placement="top" class="ml-3 fas fa-question-circle"></i></label>
                                <input mask="(00) 0000-0000" placeholder="Informe seu telefone ex: (00) 0000-0000" type="text" name='telefone' formControlName="telefone" class="form-control">
                            </div>
                            <div class="form-group col-sm-12 col-md-4">
                                <label class="form-label">Celular <i mdbTooltip='Este campo só é obrigatório caso o campo "Telefone" não seja preenchido.'  placement="top" class="ml-3 fas fa-question-circle"></i></label>
                                <input mask="(00) 00000-0000" name='celular' formControlName="celular" placeholder="Informe seu celular ex: (00) 00000-0000" type="text" class="form-control">
                            </div>
                        </div>
                    </form>
                </form>
                <div class="custom-box col-12 p-2">
                    <div class="text-center">
                        <h2 class="form-titulo">Informe os dados de Ativo</h2>
                        <small>Informe abaixo os dados do ativo</small>
                    </div>
                    <form class="col-12 p-4">
                        <div class="form-row">
                            <div class="form-group col-sm-4">
                                <label for="" class="form-label">Código Ativo <b class="text-danger">*</b></label>
                                <input name="codigoAtivo" type="text" [(ngModel)]="codigoAtivo.codigoAtivo" class="form-control custom-input">
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="" class="form-label">Data Aquisição/Compra <b class="text-danger">*</b></label>
                                <input name="dataAquisicao" type="date" [(ngModel)]="codigoAtivo.dataAquisicao" class="form-control custom-input" max="9999-12-31" appLimitarAno>
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="" class="form-label">Valor Aquisição/Compra</label>
                                <input name="valorAquisicao" prefix="R$ " mask="separator.2" thousandSeparator="." type="text" [(ngModel)]="codigoAtivo.valorInvestido" class="form-control custom-input">
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="" class="form-label">Data Vencimento</label>
                                <input name="dataVencimento" type="date" [(ngModel)]="codigoAtivo.dataVencimento" class="form-control custom-input" max="9999-12-31" appLimitarAno>
                            </div>
                        </div>
                        <div class="form-row">
                            <button (click)="validaCodigoAtivo()" class="btn">Adicionar</button>
                        </div>
                        <div *ngIf="tableAtivos.length != 0" class="form-row mt-3">
                            <table class="table">
                                <thead id="custom">
                                    <tr>
                                        <td></td>
                                        <th>Código Ativo</th>
                                        <th>Data Aquisição/Compra</th>
                                        <th>Valor Aquisição/Compra</th>
                                        <th>Data Vencimento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let data of tableAtivos">
                                        <td (click)="deleteAtivo(data)" >
                                            <i style="color: #f00;" class="far fa-trash-alt"></i>
                                        </td>
                                        <td>{{data?.codigoAtivo}}</td>
                                        <td>{{data?.dataAquisicao | date: 'dd/MM/yyyy'}}</td>
                                        <td>{{data?.valorInvestido | currency: 'BRL'}}</td>
                                        <td>{{data?.dataVencimento | date: 'dd/MM/yyyy'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </form>
                </div>
                <div class="custom-box col-12 mt-3 p-4">
                <form class="col-12 mt-3" [formGroup]="formSolicitacao">

                        <div class="text-center">
                            <h2 class="form-titulo">Dados da Conta para Depósito</h2>
                            <small>Informe abaixo os dados da conta em que deseja receber sua garantia</small>
                    </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12">
                                <label class="label-form" >Banco para Depósito <b class="text-danger">*</b></label>
                                <select id="listaBancos" type="text" name="nomeBanco" formControlName="codigoBanco" class="form-control custom-input form-icon-trailing" (change)="onBancoChange($event.target.value)">
                                  <option *ngFor="let banco of arrayBancos" [value]="banco.nome">{{banco.nome}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12 col-md-3">
                                <label for="" class="form-label">Tipo de Conta <b class="text-danger">*</b></label>
                                <select formControlName="tipoConta" name="tipoConta" class="form-control custom-input">
                                    <option value="">Selecione uma opção</option>
                                    <option value="poupanca">Conta Poupança</option>
                                    <option value="corrente">Conta Corrente</option>
                                </select>
                            </div>
                            <div class="form-group col-sm-12 col-md-3">
                                <label for="" class="form-label">Agência <b class="text-danger">*</b></label>
                                <input
                                  formControlName="agencia"
                                  name="agencia"
                                  type="text"
                                  class="form-control custom-input"
                                  inputmode="numeric"
                                  mask="0000">
                            </div>
                            <div *ngIf="isBancoDoBrasil()" class="form-group col-sm-12 col-md-3">
                                <label class="form-label">Dígito Agência </label>
                                <input
                                  formControlName="dgAgencia"
                                  maxlength="1"
                                  (input)="validateDataBank($event)"
                                  type="text"
                                  class="form-control custom-input">
                            </div>
                            <div class="form-group col-sm-12 col-md-3">
                                <label for="" class="form-label">Conta <b class="text-danger">*</b></label>
                                <input
                                  formControlName="conta"
                                  name="conta"
                                  type="text"
                                  class="form-control custom-input"
                                  maxlength="12"
                                  (input)="validateDataBank($event)">
                            </div>
                            <div class="form-group col-sm-12 col-md-3">
                                <label for="" class="form-label">Dígito Conta <b class="text-danger">*</b></label>
                                <input
                                  formControlName="dgConta"
                                  name="dgAgencia"
                                  type="text"
                                  class="form-control custom-input"
                                  maxlength="1"
                                  (input)="validateDataBank($event)">
                            </div>
                        </div>

                        <!-- <div class="custom-box col-12 mt-3 p-2">
                        <div class="text-center">
                            <h2 class="form-titulo">Endereço</h2>
                            <small>Informe abaixo os dados do seu endereço</small>
                        </div>
                        <div class="form-row">
                            <button *ngIf="query.tipoUsuario == 'ENTIDADE'" (click)="listaEnderecoUsuario()" class="btn my-5">Usar endereço cadastrado</button>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12 col-md-4">
                                <label class="form-label">CEP <b class="text-danger">*</b></label>
                                <input (change)="consultaEndereco($event)" name="cep" maxlength="9" mask="00000-000" [desabilitarEndereco] formControlName="cep" type="text" class="form-control">
                            </div>
                            <div class="form-group col-sm-12 col-md-4">
                                <label class="form-label">País <b class="text-danger">*</b></label>
                                <input [desabilitarEndereco] formControlName="pais" name="pais" type="text" class="form-control">
                            </div>
                            <div class="form-group col-sm-12 col-md-4">
                                <label class="form-label">Estado <b class="text-danger">*</b></label>
                                <select [desabilitarEndereco] formControlName="estado" name="estado" class="form-control">
                                    <option value="">Selecione uma das opções</option>
                                    <option *ngFor='let estado of estados' [value]="estado.sigla">{{estado.nome}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12 col-md-6">
                                <label class="form-label">Endereço <b class="text-danger">*</b></label>
                                <input [desabilitarEndereco] formControlName="endereco" name="endereco" type="text" class="form-control">
                            </div>
                            <div class="form-group col-sm-12 col-md-3">
                                <label class="form-label">Bairro <b class="text-danger">*</b></label>
                                <input [desabilitarEndereco] formControlName="bairro" type="text" name="bairro" class="form-control">
                            </div>
                            <div class="form-group col-sm-12 col-md-3">
                                <label class="form-label">Cidade <b class="text-danger">*</b></label>
                                <input [desabilitarEndereco] formControlName="cidade" name="cidade" class="form-control">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12 col-md-8">
                                <label class="form-label">Número / Complemento <b class="text-danger">*</b></label>
                                <input [desabilitarEndereco] formControlName="complemento" name="complemento" type="text" class="form-control">
                            </div>
                        </div>
                        </div> -->
                <div class="row d-flex justify-content-center mt-5">
                    <button (click)="solicitarDpge = false" class="btn btn-disabled mr-5">Voltar</button>
                    <button (click)="realizarSolicitacao()" class="btn">Concluir</button>
                </div>
                </form>
                </div>
         </div>
        </div>

    </div>
</div>
</app-sidenav>
